import RankingsPage from './RankingsPage';
import VoteNotification from './VoteNotification';
import VotesModal from './VotesModal';
import Voters from './Voters';

export const components = {
  RankingsPage,
  VoteNotification,
  VotesModal,
  Voters,
};
